import { useCallback } from 'react';
import { ServiceRegistry } from '@/services/ServiceRegistry';
import { PendingEmailImportsQueue } from '@/components/messages/PendingEmailImportsQueue';

interface PendingEmailImportsProps {
  companyId: string;
  /** Opens the given thread in the main Messages pane — see
   * {@link PendingEmailImportRow}'s doc comment for why review always routes through here. */
  onOpenThread: (threadId: string) => void;
}

/**
 * Per-company approval queue for imported email threads (issue #290). Scoped to the active
 * company only — a platform admin browsing a specific company's Messages page reviews that
 * company's queue, same as everything else on this page. See {@link PendingEmailImportsQueue}.
 */
export function PendingEmailImports({ companyId, onOpenThread }: PendingEmailImportsProps) {
  const load = useCallback(() => ServiceRegistry.getEmailThreadService().listPendingConnections(companyId), [companyId]);

  return <PendingEmailImportsQueue load={load} titleKey="pendingTitle" onOpenThread={onOpenThread} />;
}
